import {
  GET_VIDEO_CONTENT,
  GET_VIDEO_CONTENT_ITEM,
  SET_VIDEO_PAGE,
  SET_VIDEO_SEARCH,
  SET_VIDEO_SORT,
  SET_VIDEO_PUBLISHED_FILTER,
} from '../../shared/constants/ActionTypes';

const initialState = {
  videos: [],
  total: 0,
  page: 1,
  search: '',
  sortBy: '',
  publishedFilter: 'all',
  currentVideo: null,
};

const videoReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_VIDEO_CONTENT:
      return {
        ...state,
        videos: action.payload.videos,
        total: action.payload.total,
      };
    case GET_VIDEO_CONTENT_ITEM:
      return {
        ...state,
        currentVideo: action.payload,
      };
    case SET_VIDEO_PAGE:
      return {
        ...state,
        page: action.payload,
      };
    case SET_VIDEO_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_VIDEO_SORT:
      return {
        ...state,
        sortBy: action.payload,
      };
    case SET_VIDEO_PUBLISHED_FILTER:
      return {
        ...state,
        publishedFilter: action.payload,
        page: 1,
      };
    default:
      return state;
  }
};

export default videoReducer;
